<template>
  <div class="front-page">
    <b-container>
      <b-row>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <h3>Alle Leistungen</h3>
          <OZGImplentationStatusGraph
            query="on-min-feature"
            :onlyOZGRelevant="onlyOZGRelevant"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <h3>Mindestens eine Leistungen</h3>

          <OZGImplentationStatusGraph
            query="on-max-feature"
            :onlyOZGRelevant="onlyOZGRelevant"
          />
        </div>
      </b-row>
      <b-row>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <p class="switch-container">
            alle Implementierungsstufen
            <label class="switch">
              <input v-model="onlyOZGRelevant" type="checkbox" />
              <span class="slider"></span> </label
            ><span>gesetzeskonforme Implementierungsstufen</span>
          </p>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import OZGImplentationStatusGraph from "../OZGImplentationStatusGraph";

export default {
  name: "OZGImplementationLevelSwitchExplorer",
  components: { OZGImplentationStatusGraph },
  data: function() {
    return {
      onlyOZGRelevant: false
    };
  }
};
</script>

<style scoped>
h3 {
  text-align: center;
}
.switch-container {
  text-align: center;
  font-family: "Bitter", serif;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  top: 8px;
  height: 22px;
  margin-left: 7px;
  margin-right: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #111111;
}

input:focus + .slider {
  box-shadow: #111111;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
</style>
